import React from 'react';

const useVisible = (isVisible: boolean) => {
  const ref = React.useRef<any>(null);
  const [isComponentVisible, setIsComponentVisible] = React.useState(isVisible);

  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return { ref, isComponentVisible, setIsComponentVisible };
};

export default useVisible;
